<ul
  *ngIf="buildTabList$ | async as tabs"
  class="tabs-container border-bottom-0 mb-0"
  data-test="tabs-container"
  role="tablist"
  [class.no-dropdown]="tabs.dropdownActive === false"
>
  <li
    *ngFor="let tab of tabs.primaryTabs; trackBy: trackByPrimaryTab"
    class="tab-label"
    [class.tab-active]="tab.active"
    [class.flex-tab]="tabClass$ | async"
  >
    <a
      class="font-family-regular nav-link apply-text-active p-0 h-100 w-100 d-flex align-items-center justify-content-center"
      [routerLink]="tab.route | lowercase"
      [queryParams]="tab.qp"
      (click)="updateTab(tab, $event, tabs)"
      >{{ tab.tabTitle | titlecase }}
      <span *ngIf="tab.count" class="count apply-text-active flo-footnote"
        >({{ tab.count }})
      </span>
    </a>
  </li>

  <li
    *ngIf="tabs.collapsibleTabs && tabs.collapsibleTabs?.length"
    class="tab-label"
    ngbDropdown
    [class.flex-tab]="tabClass$ | async"
    (openChange)="handleOpenChange($event)"
  >
    <a
      tabIndex="0"
      [routerLink]="[]"
      class="font-family-regular nav-link apply-text-active d-flex align-items-center"
      ngbDropdownToggle
      >More
      <span class="dropdown-arrow" [class.rotate-svg-180]="dropdownExpanded">
        <flo-svg-icon class="svg-vertical-align-top" icon="angle-down" width="2em"></flo-svg-icon>
      </span>
    </a>
    <ul ngbDropdownMenu>
      <li
        *ngFor="
          let moreTab of tabs.collapsibleTabs;
          trackBy: trackByCollapsibleTab
        "
        class="tab-label"
        [class.tab-active]="moreTab.active"
        [class.flex-tab]="tabClass$ | async"
        ngbDropdownItem
      >
        <a
          class="font-family-regular nav-link apply-text-hover apply-text-active p-0 h-100 w-100 d-flex align-items-center justify-content-center"
          [routerLink]="moreTab.route | lowercase"
          [queryParams]="moreTab.qp"
          (click)="updateTab(moreTab, $event, tabs)"
        >
          {{ moreTab.tabTitle | titlecase }}
          <span
            *ngIf="moreTab.count"
            class="count apply-text-active flo-footnote"
            >({{ moreTab.count }})
          </span>
        </a>
      </li>
    </ul>
  </li>
</ul>
<ng-content></ng-content>
